const initializeBackBtn = () => {
    if (!document) return;

    const backBtnEl = document.querySelector(".js-back-btn");

    if (!backBtnEl) return;

    backBtnEl.addEventListener("click", (event) => {
        event.preventDefault();

        if (!window) return;

        window.history.back();
    });
};

initializeBackBtn();
